
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Indian Classical <span >Vocal Performance Nagpur</span></h2>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <p class="text-justify">Pandit Sanjeev Abhyankar, the Maestro from the Mewati Gharana, is an artist
                        of
                        international acclaim in the field of Hindustani Classical and Devotional Music.
                        He is an Iconic singer of his generation. An extremely popular artist, he has been
                        the inspiration for the last few generations. In a career spanning over 30 years,
                        he has assumed the mantle of a role model of dedication, hard work, patience
                        and perseverance.
                    </p>
                    <p class="text-justify">
                        Blessed with an exceptionally sweet voice, his vocation in life was clear right
                        from the age of three. Born on the 5th October 1969, Sanjeev started learning
                        Hindustani Classical Music, from the tender age of eight. His mother
                        Dr. Smt.Shobha Abhyankar, Pandit Pimpalkhare ji of the Gwalior Gharana and
                        Padmavibhushan Pandit Jasraj ji of the Mewati Gharana have groomed him.
                    </p>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar3.webp"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                    <h4 class="mt-3 text-center"><strong>Pandit Sanjeev Abhyankar</strong></h4>
                </div>
                <div class="col-md-12">
                    <p class="text-justify">
                        In 1981, Sanjeev, the child prodigy, rendered his first stage performance in
                        Mumbai, at the age of eleven. Since then, he has traveled extensively all over the
                        country performing in all the prestigious conferences and art circles, several
                        times. He has a distinction of performing in over 200 different cities all over the
                        world till date. He has spread the fragrance of Indian Classical music in U.S.A.,
                        Canada, Australia, New Zealand, Europe, Africa and the Middle East.
                    </p>
                    <p class="text-justify">
                        As a composer, he has several classical and devotional compositions to his
                        credit. Many of his compositions which is a recording of over fourteen hours, are
                        free downloadable on his website www.sanjeevabhyankar.com . As a Guru he is
                        imparting his knowledge to selected talented students. His students have also
                        started making a mark in the field of classical music.
                    </p>
                    <p class="text-justify">
                        He has received many awards which include the President award and the Top
                        grade from the All India Radio, the prestigious Kumar Gandharva National Award
                        2008 by Govt. of Madhya Pradesh, the coveted National Award 1998 as the best
                        male playback singer for the Hindi film Godmother, F.I.E. Foundation National
                        Award in 1996, the title Sur-Ratna and the Pandit Jasraj Gaurav Puraskar, Gan-
                        Saraswati Kishori Amonkar Puraskar, to name a few.
                    </p>
                    <p class="text-justify">
                        He has recorded over 100 albums by all the reputed music labels, which have
                        been highly acclaimed all over the world.
                        Sanjeev has rendered the entire “Dasbodh” containing 7800 verses for an audio
                        book project by the Govt of Maharashtra.
                    </p>
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-md-4 mb-5">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-shende.webp"
                        alt="GHRSCF" style="width: 100%;">
                </div>
                <h4 class="mt-3 text-center"><strong>Sawani Shende</strong></h4>
            </div>
            <div class="col-md-8">
                <p class="text-justify">Sawani’s music is a beautiful soul searching journey where she mesmerizes
                    audiences with pure yet aesthetical rendering of the Raga. Sawani’s confidence and mastery in
                    Khayals, her crystal clear diction and overall sensitivity in presentation takes every performance
                    to a very high aesthetic level.
                </p>
                <p class="text-justify">
                    She unfolds the Raga in a highly intellectual manner with spontaneous combinations which give the
                    listeners a different happiness each time they hear her sing.
                </p>
                <p class="text-justify">
                    Her rendition of semi-classical genres highlights the emotive and expressive quality of Indian
                    classical music and adds a very important dimension to her performance leaving audiences spellbound.
                    That’s the reason why Sawani’s mehfils are highly acclaimed by both the experts and the general
                    audiences of music.
                </p>
            </div>
            <div class="col-lg-6">
                <p><strong>Let’s meet you then.</strong></p>
                <p><strong>Topic:</strong> Vocal Performance </p>
                <p><strong>Date –</strong> Sunday, 23<sup>rd</sup> June 2023 </p>
                <p><strong>Time –</strong> 6:30 pm - Sharp (Grab your seats before time)</p>
                <p><strong>Venue:</strong> Deshpande Hall - Nagpur </p>
                <p><strong class="fw-bold text-dark">Performer:</strong> Sawani Shende (Indian Classical Vocalist) </p>
                <h6><strong>Accompanists </strong> </h6>
                <p>Shri Sandesh Popatkar -On Tabla</p>
                <p>Shri Shrikant Pise - On Harmonium</p>
                <p><strong class="fw-bold text-dark">Performer:</strong> Sanjeev Abhyankar (Indian Classical Vocalist)
                </p>
                <h6><strong>Accompanists </strong> </h6>
                <p>Shri Ajinkya Joshi on Tabla </p>
                <p>Shri. Abhishek Shinkar on Harmonium </p>
            </div>
            <div class="col-lg-6">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhynkar-event-ngp.webp"
                        alt="GHRSCF" style="width: 100%;">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end"><a href="media#media_classical" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <iframe src="https://drive.google.com/file/d/1vRoJy8Oly0PvJByyCO2mS9ZAGVMf91Fz/preview" height="250"
                        width="100%"></iframe>

                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#sanjeev-ngp" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>




                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
